<template>
  <v-container fluid class="fill-height"> 
    
    <v-row class="text-center align-center justify-center fill-height"> 
      
      <v-col class="mb-4">
        
        <h1 class="display-2 font-weight-bold mb-3">
          Bienvenido al sistema de WI PLANNING
        </h1>
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',

  data: () => ({
    
  }),
}
</script>
<style scoped>
.v-container.fill-height {
    min-height: 90vh;
}

.display-2 {
    color: #212121; 
    margin-bottom: 40px !important;
    text-align: center; 
    
    font-size: 5.5rem !important; 

    line-height: 1.1; 
    
    text-shadow: 
        2px 2px 0 #bdbdbd,  
        5px 5px 8px rgba(0, 0, 0, 0.3); 
    
    transition: all 0.3s ease-in-out;
}

.display-2:hover {
    transform: translateY(-3px) scale(1.02);
    text-shadow: 
        2px 2px 0 #a1a1a1,
        8px 8px 10px rgba(0, 0, 0, 0.4); 
}

</style>
